import { supabase } from '@/integrations/supabase/client';

export async function getDefaultCurrency(userId: string): Promise<string | null> {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('default_currency')
    .eq('id', userId)
    .maybeSingle();

  if (error) return null;
  const dc = (data as any)?.default_currency;
  return (typeof dc === 'string' && dc.trim()) ? String(dc).toUpperCase() : null;
}
